/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Watchlist.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddSymbolReplay
 */
export interface AddSymbolReplay {
    /**
     * 
     * @type {number}
     * @memberof AddSymbolReplay
     */
    'modifiedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddSymbolReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface Cell
 */
export interface Cell {
    /**
     * 
     * @type {number}
     * @memberof Cell
     */
    'dataId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Cell
     */
    'value'?: number;
}
/**
 * 
 * @export
 * @interface DeleteReplay
 */
export interface DeleteReplay {
    /**
     * 
     * @type {number}
     * @memberof DeleteReplay
     */
    'deletedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeleteReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface FetchReplay
 */
export interface FetchReplay {
    /**
     * 
     * @type {Array<Snapshot>}
     * @memberof FetchReplay
     */
    'items'?: Array<Snapshot>;
    /**
     * 
     * @type {string}
     * @memberof FetchReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface HeaderInfo
 */
export interface HeaderInfo {
    /**
     * 
     * @type {string}
     * @memberof HeaderInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof HeaderInfo
     */
    'binding'?: string;
}
/**
 * 
 * @export
 * @interface HeaderReplay
 */
export interface HeaderReplay {
    /**
     * 
     * @type {Array<HeaderInfo>}
     * @memberof HeaderReplay
     */
    'items'?: Array<HeaderInfo>;
}
/**
 * 
 * @export
 * @interface ListReplay
 */
export interface ListReplay {
    /**
     * 
     * @type {Array<WatchlistShortInfo>}
     * @memberof ListReplay
     */
    'items'?: Array<WatchlistShortInfo>;
    /**
     * 
     * @type {string}
     * @memberof ListReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ModelsReplay
 */
export interface ModelsReplay {
    /**
     * 
     * @type {Array<RealtimeFieldInfo>}
     * @memberof ModelsReplay
     */
    'Live'?: Array<RealtimeFieldInfo>;
    /**
     * 
     * @type {Array<ScreenerColumnInfo>}
     * @memberof ModelsReplay
     */
    'Performance'?: Array<ScreenerColumnInfo>;
    /**
     * 
     * @type {Array<ScreenerColumnInfo>}
     * @memberof ModelsReplay
     */
    'Valuation'?: Array<ScreenerColumnInfo>;
    /**
     * 
     * @type {Array<ScreenerColumnInfo>}
     * @memberof ModelsReplay
     */
    'AnalysisRecommendations'?: Array<ScreenerColumnInfo>;
    /**
     * 
     * @type {Array<ScreenerColumnInfo>}
     * @memberof ModelsReplay
     */
    'TechnicalAnalysis'?: Array<ScreenerColumnInfo>;
    /**
     * 
     * @type {string}
     * @memberof ModelsReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface NewReplay
 */
export interface NewReplay {
    /**
     * 
     * @type {string}
     * @memberof NewReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface RealtimeFieldInfo
 */
export interface RealtimeFieldInfo {
    /**
     * 
     * @type {string}
     * @memberof RealtimeFieldInfo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof RealtimeFieldInfo
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RealtimeFieldInfo
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RealtimeFieldInfo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RealtimeFieldInfo
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof RealtimeFieldInfo
     */
    'width'?: number;
    /**
     * 
     * @type {string}
     * @memberof RealtimeFieldInfo
     */
    'info'?: string;
}
/**
 * 
 * @export
 * @interface RemoveSymbolReplay
 */
export interface RemoveSymbolReplay {
    /**
     * 
     * @type {number}
     * @memberof RemoveSymbolReplay
     */
    'modifiedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RemoveSymbolReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface RenameReplay
 */
export interface RenameReplay {
    /**
     * 
     * @type {number}
     * @memberof RenameReplay
     */
    'modifiedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RenameReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface ScoreCell
 */
export interface ScoreCell {
    /**
     * 
     * @type {number}
     * @memberof ScoreCell
     */
    'fieldId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScoreCell
     */
    'fieldName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ScoreCell
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof ScoreCell
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreCell
     */
    'average'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreCell
     */
    'last'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreCell
     */
    'max'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoreCell
     */
    'min'?: number;
}
/**
 * 
 * @export
 * @interface ScreenerColumnInfo
 */
export interface ScreenerColumnInfo {
    /**
     * 
     * @type {number}
     * @memberof ScreenerColumnInfo
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenerColumnInfo
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenerColumnInfo
     */
    'default'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ScreenerColumnInfo
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScreenerColumnInfo
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScreenerColumnInfo
     */
    'width'?: number;
    /**
     * 
     * @type {string}
     * @memberof ScreenerColumnInfo
     */
    'info'?: string;
}
/**
 * 
 * @export
 * @interface Snapshot
 */
export interface Snapshot {
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Snapshot
     */
    'name'?: string;
    /**
     * 
     * @type {Array<ScoreCell>}
     * @memberof Snapshot
     */
    'indicators'?: Array<ScoreCell>;
    /**
     * 
     * @type {Array<Cell>}
     * @memberof Snapshot
     */
    'ValuationCells'?: Array<Cell>;
    /**
     * 
     * @type {Array<Cell>}
     * @memberof Snapshot
     */
    'TechnicalAnalysisCells'?: Array<Cell>;
    /**
     * 
     * @type {Array<Cell>}
     * @memberof Snapshot
     */
    'PerformanceCells'?: Array<Cell>;
    /**
     * 
     * @type {Array<Cell>}
     * @memberof Snapshot
     */
    'AnalysisRecommendationsCells'?: Array<Cell>;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}
/**
 * 
 * @export
 * @interface SymbolListReplay
 */
export interface SymbolListReplay {
    /**
     * 
     * @type {string}
     * @memberof SymbolListReplay
     */
    'error'?: string;
    /**
     * 
     * @type {Array<SymbolShortInfo>}
     * @memberof SymbolListReplay
     */
    'symbols'?: Array<SymbolShortInfo>;
}
/**
 * 
 * @export
 * @interface SymbolShortInfo
 */
export interface SymbolShortInfo {
    /**
     * 
     * @type {string}
     * @memberof SymbolShortInfo
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolShortInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SymbolShortInfo
     */
    'entityId'?: string;
}
/**
 * 
 * @export
 * @interface SyncFieldsData
 */
export interface SyncFieldsData {
    /**
     * 
     * @type {number}
     * @memberof SyncFieldsData
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SyncFieldsData
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SyncFieldsData
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof SyncFieldsData
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface SyncFieldsReplay
 */
export interface SyncFieldsReplay {
    /**
     * 
     * @type {number}
     * @memberof SyncFieldsReplay
     */
    'modifiedCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SyncFieldsReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SyncFieldsRequest
 */
export interface SyncFieldsRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncFieldsRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SyncFieldsRequest
     */
    'category'?: string;
    /**
     * 
     * @type {Array<SyncFieldsData>}
     * @memberof SyncFieldsRequest
     */
    'Fields'?: Array<SyncFieldsData>;
}
/**
 * 
 * @export
 * @interface SyncRealtimeData
 */
export interface SyncRealtimeData {
    /**
     * 
     * @type {string}
     * @memberof SyncRealtimeData
     */
    'code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SyncRealtimeData
     */
    'enable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SyncRealtimeData
     */
    'order'?: number;
    /**
     * 
     * @type {number}
     * @memberof SyncRealtimeData
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface SyncReltimeFieldsRequest
 */
export interface SyncReltimeFieldsRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncReltimeFieldsRequest
     */
    'id'?: string;
    /**
     * 
     * @type {Array<SyncRealtimeData>}
     * @memberof SyncReltimeFieldsRequest
     */
    'RealtimeFields'?: Array<SyncRealtimeData>;
}
/**
 * 
 * @export
 * @interface WatchlistShortInfo
 */
export interface WatchlistShortInfo {
    /**
     * 
     * @type {string}
     * @memberof WatchlistShortInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WatchlistShortInfo
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof WatchlistShortInfo
     */
    'securityCount'?: number;
}

/**
 * DashboardServiceApi - axios parameter creator
 * @export
 */
export const DashboardServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncReltimeFieldsRequest} [syncReltimeFieldsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realtimeSyncRealtimeFieldsPost: async (identityToken: string, syncReltimeFieldsRequest?: SyncReltimeFieldsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('realtimeSyncRealtimeFieldsPost', 'identityToken', identityToken)
            const localVarPath = `/realtime/sync-realtime-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncReltimeFieldsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistAddSymbolGet: async (identityToken: string, id?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistAddSymbolGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/add-symbol`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistDefaultupdateGet: async (identityToken: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistDefaultupdateGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/defaultupdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistDeleteGet: async (identityToken: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistDeleteGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistHeadersGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistHeadersGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/headers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistListGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistListGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistModelsGet: async (identityToken: string, id?: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistModelsGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistNewGet: async (identityToken: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistNewGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistRemoveSymbolGet: async (identityToken: string, id?: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistRemoveSymbolGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/remove-symbol`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistRenameGet: async (identityToken: string, id?: string, name?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistRenameGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/rename`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistSymbolListGet: async (identityToken: string, id?: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistSymbolListGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/symbol-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncFieldsRequest} [syncFieldsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistSyncFieldsPost: async (identityToken: string, syncFieldsRequest?: SyncFieldsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistSyncFieldsPost', 'identityToken', identityToken)
            const localVarPath = `/watchlist/sync-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncFieldsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistUpdatefieldnamesGet: async (identityToken: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('watchlistUpdatefieldnamesGet', 'identityToken', identityToken)
            const localVarPath = `/watchlist/updatefieldnames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardServiceApi - functional programming interface
 * @export
 */
export const DashboardServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncReltimeFieldsRequest} [syncReltimeFieldsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async realtimeSyncRealtimeFieldsPost(identityToken: string, syncReltimeFieldsRequest?: SyncReltimeFieldsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncFieldsReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.realtimeSyncRealtimeFieldsPost(identityToken, syncReltimeFieldsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistAddSymbolGet(identityToken: string, id?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddSymbolReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistAddSymbolGet(identityToken, id, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistDefaultupdateGet(identityToken: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistDefaultupdateGet(identityToken, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistDeleteGet(identityToken: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistDeleteGet(identityToken, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistHeadersGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeaderReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistHeadersGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistListGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistListGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistModelsGet(identityToken: string, id?: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelsReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistModelsGet(identityToken, id, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistNewGet(identityToken: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistNewGet(identityToken, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistRemoveSymbolGet(identityToken: string, id?: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveSymbolReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistRemoveSymbolGet(identityToken, id, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistRenameGet(identityToken: string, id?: string, name?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistRenameGet(identityToken, id, name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistSymbolListGet(identityToken: string, id?: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SymbolListReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistSymbolListGet(identityToken, id, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncFieldsRequest} [syncFieldsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistSyncFieldsPost(identityToken: string, syncFieldsRequest?: SyncFieldsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncFieldsReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistSyncFieldsPost(identityToken, syncFieldsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async watchlistUpdatefieldnamesGet(identityToken: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RenameReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.watchlistUpdatefieldnamesGet(identityToken, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardServiceApi - factory interface
 * @export
 */
export const DashboardServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncReltimeFieldsRequest} [syncReltimeFieldsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        realtimeSyncRealtimeFieldsPost(identityToken: string, syncReltimeFieldsRequest?: SyncReltimeFieldsRequest, options?: any): AxiosPromise<SyncFieldsReplay> {
            return localVarFp.realtimeSyncRealtimeFieldsPost(identityToken, syncReltimeFieldsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistAddSymbolGet(identityToken: string, id?: string, entityId?: string, options?: any): AxiosPromise<AddSymbolReplay> {
            return localVarFp.watchlistAddSymbolGet(identityToken, id, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistDefaultupdateGet(identityToken: string, id?: string, options?: any): AxiosPromise<RenameReplay> {
            return localVarFp.watchlistDefaultupdateGet(identityToken, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistDeleteGet(identityToken: string, id?: string, options?: any): AxiosPromise<DeleteReplay> {
            return localVarFp.watchlistDeleteGet(identityToken, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistHeadersGet(identityToken: string, culture?: string, options?: any): AxiosPromise<HeaderReplay> {
            return localVarFp.watchlistHeadersGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistListGet(identityToken: string, culture?: string, options?: any): AxiosPromise<ListReplay> {
            return localVarFp.watchlistListGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistModelsGet(identityToken: string, id?: string, culture?: string, options?: any): AxiosPromise<ModelsReplay> {
            return localVarFp.watchlistModelsGet(identityToken, id, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistNewGet(identityToken: string, name?: string, options?: any): AxiosPromise<NewReplay> {
            return localVarFp.watchlistNewGet(identityToken, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistRemoveSymbolGet(identityToken: string, id?: string, entityId?: string, options?: any): AxiosPromise<RemoveSymbolReplay> {
            return localVarFp.watchlistRemoveSymbolGet(identityToken, id, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistRenameGet(identityToken: string, id?: string, name?: string, options?: any): AxiosPromise<RenameReplay> {
            return localVarFp.watchlistRenameGet(identityToken, id, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistSymbolListGet(identityToken: string, id?: string, culture?: string, options?: any): AxiosPromise<SymbolListReplay> {
            return localVarFp.watchlistSymbolListGet(identityToken, id, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SyncFieldsRequest} [syncFieldsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistSyncFieldsPost(identityToken: string, syncFieldsRequest?: SyncFieldsRequest, options?: any): AxiosPromise<SyncFieldsReplay> {
            return localVarFp.watchlistSyncFieldsPost(identityToken, syncFieldsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        watchlistUpdatefieldnamesGet(identityToken: string, id?: string, options?: any): AxiosPromise<RenameReplay> {
            return localVarFp.watchlistUpdatefieldnamesGet(identityToken, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardServiceApi - object-oriented interface
 * @export
 * @class DashboardServiceApi
 * @extends {BaseAPI}
 */
export class DashboardServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {SyncReltimeFieldsRequest} [syncReltimeFieldsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public realtimeSyncRealtimeFieldsPost(identityToken: string, syncReltimeFieldsRequest?: SyncReltimeFieldsRequest, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).realtimeSyncRealtimeFieldsPost(identityToken, syncReltimeFieldsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistAddSymbolGet(identityToken: string, id?: string, entityId?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistAddSymbolGet(identityToken, id, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistDefaultupdateGet(identityToken: string, id?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistDefaultupdateGet(identityToken, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistDeleteGet(identityToken: string, id?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistDeleteGet(identityToken, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistHeadersGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistHeadersGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistListGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistListGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistModelsGet(identityToken: string, id?: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistModelsGet(identityToken, id, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistNewGet(identityToken: string, name?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistNewGet(identityToken, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistRemoveSymbolGet(identityToken: string, id?: string, entityId?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistRemoveSymbolGet(identityToken, id, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistRenameGet(identityToken: string, id?: string, name?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistRenameGet(identityToken, id, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistSymbolListGet(identityToken: string, id?: string, culture?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistSymbolListGet(identityToken, id, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {SyncFieldsRequest} [syncFieldsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistSyncFieldsPost(identityToken: string, syncFieldsRequest?: SyncFieldsRequest, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistSyncFieldsPost(identityToken, syncFieldsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardServiceApi
     */
    public watchlistUpdatefieldnamesGet(identityToken: string, id?: string, options?: AxiosRequestConfig) {
        return DashboardServiceApiFp(this.configuration).watchlistUpdatefieldnamesGet(identityToken, id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QueryServiceApi - axios parameter creator
 * @export
 */
export const QueryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryFetchDataGet: async (identityToken: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('queryFetchDataGet', 'identityToken', identityToken)
            const localVarPath = `/query/fetch-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryServiceApi - functional programming interface
 * @export
 */
export const QueryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryFetchDataGet(identityToken: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryFetchDataGet(identityToken, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QueryServiceApi - factory interface
 * @export
 */
export const QueryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryFetchDataGet(identityToken: string, id?: string, options?: any): AxiosPromise<FetchReplay> {
            return localVarFp.queryFetchDataGet(identityToken, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryServiceApi - object-oriented interface
 * @export
 * @class QueryServiceApi
 * @extends {BaseAPI}
 */
export class QueryServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryServiceApi
     */
    public queryFetchDataGet(identityToken: string, id?: string, options?: AxiosRequestConfig) {
        return QueryServiceApiFp(this.configuration).queryFetchDataGet(identityToken, id, options).then((request) => request(this.axios, this.basePath));
    }
}



